webpackJsonp([147215635427136],{

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Collections = __webpack_require__(25);
	
	var _Collections2 = _interopRequireDefault(_Collections);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Collections2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'sync'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'sync()'
	      ),
	      ' method is a wrapper over the ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/sync/' },
	        'sync'
	      ),
	      ' function, and allows you to modify how server calls are made for the collection.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { sync } from \'lore-models\';\n      ...\n      sync: function(method, collection, options) {\n        return sync(method, collection, options);\n      },\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can use override this method to take control of the server call made to the API, but it\'s unclear what you might want to do that. If a use case can be found, this page will be updated to demonstrate it.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-collections-properties-sync-js-810153d8a65d4c2074a7.js